module.exports = __webpack_public_path__ + "img/danao.4709c882.png";